import React from 'react';
import './info.scss';
import defaultImage from '../../assets/user.jpeg';

export class Info extends React.Component<any, any> {
  typingTimer: any = null;
  deletingTimer: any = null;

  constructor(props: any) {
    super(props);
    this.state = {
      displayTitle: '',
      titleIndex: 0,
      titles: this.getTitles(props),
    };
  }

  componentDidMount() {
    this.startTyping();
  }

  componentDidUpdate(prevProps: any) {
    const prevTitles = this.getTitles(prevProps);
    const currentTitles = this.getTitles(this.props);
    if (JSON.stringify(prevTitles) !== JSON.stringify(currentTitles)) {
      this.setState({ titles: currentTitles, displayTitle: '', titleIndex: 0 }, this.startTyping);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.typingTimer);
    clearTimeout(this.deletingTimer);
  }

  getTitles = (props: any) => {
    const typicalHeading = props.infoData?.typicalHeading || '';
    if (typeof typicalHeading === 'string') {
      return typicalHeading
        .split('800')
        .map((t: string) => t.trim())
        .filter((t: string) => t.length > 0);
    }

    if (Array.isArray(typicalHeading)) {
      return typicalHeading
        .map((t: any) => String(t || '').trim())
        .filter((t: string) => t.length > 0);
    }

    return [];
  }

  startTyping = () => {
    clearTimeout(this.typingTimer);
    clearTimeout(this.deletingTimer);
    const { titles, titleIndex } = this.state;
    if (titles.length === 0) return;
    this.typeTitle(titles, titleIndex, 0);
  }

  typeTitle = (titles: string[], titleIdx: number, charIdx: number) => {
    const currentTitle = titles[titleIdx];
    if (charIdx <= currentTitle.length) {
      this.setState({ displayTitle: currentTitle.substring(0, charIdx) });
      this.typingTimer = setTimeout(() => this.typeTitle(titles, titleIdx, charIdx + 1), 80);
    } else {
      this.deletingTimer = setTimeout(() => this.deleteTitle(titles, titleIdx), 1800);
    }
  };

  deleteTitle = (titles: string[], titleIdx: number) => {
    const currentTitle = titles[titleIdx];
    let charIdx = currentTitle.length;
    const deleteChar = () => {
      if (charIdx >= 0) {
        this.setState({ displayTitle: currentTitle.substring(0, charIdx) });
        charIdx -= 1;
        this.deletingTimer = setTimeout(deleteChar, 40);
      } else {
        const nextIndex = (titleIdx + 1) % titles.length;
        this.typingTimer = setTimeout(() => this.typeTitle(titles, nextIndex, 0), 500);
      }
    };
    deleteChar();
  };

  render(): React.ReactNode {
    const infoData = this.props.infoData || {};
    const profileImage = infoData.profileImage || defaultImage;
    const { displayTitle } = this.state;
    return (
      <div className="info">
        <div className="container">
          <div className="info__wrapper">
            <div className="info__user-image">
              <img src={profileImage} alt="Profile" onError={(e: any) => e.target.src = defaultImage} />
            </div>
            <div className="info__name--section">
              <h1 className="info__name">{infoData.name}</h1>
              <p className="info__title">{displayTitle}<span className="info__cursor">|</span></p>
              <div className="info__details">
                {/* {infoData.dob && (
                  <div className="info__detail-item">
                    <span className="info__detail-label">Age:</span>
                    <span>{new Date().getFullYear() - new Date(infoData.dob).getFullYear()}</span>
                  </div>
                )} */}
                {infoData.phone && (
                  <div className="info__detail-item">
                    <span className="info__detail-label">Phone:</span>
                    <a href={`tel:+91${infoData.phone}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                      +91 {infoData.phone}
                    </a>
                  </div>
                )}
                {infoData.skypeId && (
                  <div className="info__detail-item">
                    <span className="info__detail-label">Skype Id:</span>
                    <span>{infoData.skypeId}</span>
                  </div>
                )}
                {infoData.emailId && (
                  <div className="info__detail-item">
                    <span className="info__detail-label">Email:</span>
                    <span>{infoData.emailId}</span>
                  </div>
                )}
              </div>
              <div className="info__social">
                {infoData.emailId && (
                  <a href={`mailto:${infoData.emailId}`} className="info__social-icon">
                    <i className="fas fa-envelope"></i>
                  </a>
                )}
                {infoData.facebookUrl && (
                  <a href={infoData.facebookUrl} target="_blank" rel="noopener noreferrer" className="info__social-icon">
                    <i className="fab fa-facebook"></i>
                  </a>
                )}
                {infoData.gitHubUrl && (
                  <a href={infoData.gitHubUrl} target="_blank" rel="noopener noreferrer" className="info__social-icon">
                    <i className="fab fa-github"></i>
                  </a>
                )}
                {infoData.linkedInUrl && (
                  <a href={infoData.linkedInUrl} target="_blank" rel="noopener noreferrer" className="info__social-icon">
                    <i className="fab fa-linkedin"></i>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Info;
